/* unplugin-vue-components disabled */import { render } from "./view-more.vue?vue&type=template&id=15ea7906&scoped=true"
import script from "./view-more.vue?vue&type=script&lang=js"
export * from "./view-more.vue?vue&type=script&lang=js"

import "./view-more.vue?vue&type=style&index=0&id=15ea7906&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ea7906"],['__file',"src/components/sources/view-more.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15ea7906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15ea7906', __exports__)) {
    api.reload('15ea7906', __exports__)
  }
  
  module.hot.accept("./view-more.vue?vue&type=template&id=15ea7906&scoped=true", () => {
    api.rerender('15ea7906', render)
  })

}


export default __exports__